
import StoryblokComponent from '~/components/Storyblok/Component'

export default {
  components: { StoryblokComponent },
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      const mm = this.$gsap.matchMedia(this.$el)

      // desktop
      mm.add('(min-width: 1024px)', () => {
        this.initAnim()
      })
    })
  },
  methods: {
    initAnim() {
      this.$gsap.set(this.$refs.bgImg.$el, {
        // scaleX: 1.1,
        // scaleY: 1.1,
        scale: 1,
      })
      const TL1 = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs.container,
          scrub: 0.5,
          start: 'top bottom',
          end: 'bottom top',
          // markers: true,
        },
      })

      TL1.from(this.$refs.bgImg.$el, {
        y: '-=50',
        scale: 1.1,
        duration: 2.5,
        ease: 'Power1.easeInOut',
      })
    },
  },
}
